module.exports = {
  environment: process.env.NODE_ENV,
  appEnvironment: process.env.REACT_APP_ENV,
  profiles: {
    client: {
      localStorageKey: "ali",
      devTool: {
        instanceName: "ali",
        actionBlackList: ["REDUX_STORAGE_SAVE"],
        environment: ["development", "test", "local"],
        initDevTool: true,
      },
    },
  },
};
